module.exports = __webpack_public_path__ + "img/newLogo-old.02cd354a.png";